import { Base } from "@studiometa/js-toolkit";
class Accordion extends Base {
  onBtnClick() {
    this.$refs.content.classList.toggle("hidden");
    this.$refs.icon.forEach((element) => {
      element.classList.toggle("hidden");
    });
  }
}
Accordion.config = {
  name: "Accordion",
  refs: ["btn", "content", "icon[]"],
  options: {
    activeBreakpoints: {
      type: String,
      default: "xxs xs s"
    }
  }
};
export {
  Accordion as default
};


if (module.hot) {module.hot.accept(function(err) {
if (err) {
console.error(err);
}
});
}
